"use client";

import React from "react";
import Select from "../../Select";
import type { CellRegistration } from "./EditableTableContext";

type Props = {
  options?: CellRegistration["options"];
  onCommit: (value: string) => void;
};

const BulkSelectCell: React.FC<Props> = ({ options, onCommit }) => (
  <Select
    value=""
    size="small"
    width="100%"
    onChange={v => onCommit(v)}
    options={options ?? []}
    placeholder="Select"
  />
);

export default BulkSelectCell;
